import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { UserType } from "ui/Scripts/source/models/enums";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";
import { IUserMicrosoftAccount, UserMicrosoftAccount } from "ui/Scripts/source/models/user/userMicrosoftAccount";

export interface IUserEditItem extends IEditItem {
    code: string;
    firstName: string;
    lastName: string;
    email: string;
    comment: string;
    endDate: number;
    picture: string;
    userType: number;
    portalUseType: number;
    emailNotificationType: number;
    pushNotificationType: number;
    recordEmailNotificationType: number;
    recordEmailNotificationShowExpired: boolean;
    instantMessageUserInvitationAcceptType: number;
    defaultCulture: string;
    qrCodeId: string;
    qrCodeAuthenticationTimeout: number;
    recordUserId: string;
    loginCompanyCode: string;
    hasLoggedIn: boolean;
    createUser: IModifyUser;
    modifyUser: IModifyUser;
    microsoftAccount: IUserMicrosoftAccount;
}

export class UserEditItem extends EditItem implements IUserEditItem {
    code: string;
    firstName: string;
    lastName: string;
    email: string;
    comment: string;
    endDate: number;
    picture: string;
    userType: UserType;
    portalUseType: number;
    emailNotificationType: number;
    pushNotificationType: number;
    recordEmailNotificationType: number;
    recordEmailNotificationShowExpired: boolean;
    instantMessageUserInvitationAcceptType: number;
    defaultCulture: string;
    qrCodeId: string;
    qrCodeAuthenticationTimeout: number;
    recordUserId: string;
    loginCompanyCode: string;
    hasLoggedIn: boolean;
    createUser: ModifyUser;
    modifyUser: ModifyUser;
    microsoftAccount: UserMicrosoftAccount;

    constructor();
    constructor(obj: IUserEditItem);
    constructor(obj?: any) {
        super(obj);
        this.code = obj && obj.code || "";
        this.firstName = obj && obj.firstName || "";
        this.lastName = obj && obj.lastName || "";
        this.email = obj && obj.email || "";
        this.comment = obj && obj.comment || "";
        this.endDate = obj && obj.endDate || 0;
        this.picture = obj && obj.picture || "";
        this.userType = obj && obj.userType || UserType.Normal;
        this.portalUseType = obj && obj.portalUseType || 0;
        this.emailNotificationType = obj && obj.emailNotificationType || 0;
        this.pushNotificationType = obj && obj.pushNotificationType || 0;
        this.recordEmailNotificationType = obj && obj.recordEmailNotificationType || 0;
        this.recordEmailNotificationShowExpired = obj && obj.recordEmailNotificationShowExpired || false;
        this.instantMessageUserInvitationAcceptType = obj && obj.instantMessageUserInvitationAcceptType || 0;
        this.defaultCulture = obj && obj.defaultCulture || "";
        this.qrCodeId = obj && obj.qrCodeId || "";
        this.qrCodeAuthenticationTimeout = obj && obj.qrCodeAuthenticationTimeout || 0;
        this.recordUserId = obj && obj.recordUserId || "";
        this.loginCompanyCode = obj && obj.loginCompanyCode || "";
        this.hasLoggedIn = obj && obj.hasLoggedIn || false;
        this.createUser = new ModifyUser(obj ? obj.createUser : null);
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
        this.microsoftAccount = obj && obj.microsoftAccount
            ? new UserMicrosoftAccount(obj.microsoftAccount)
            : null;
    }
}